var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/podcasts", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.podcast
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.updatePodcast.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Enter Podcast Title",
                            placeholder: "Enter Podcast Title",
                            "data-vv-name": "title",
                            "cus-name": "title"
                          },
                          model: {
                            value: _vm.podcast.title,
                            callback: function($$v) {
                              _vm.$set(_vm.podcast, "title", $$v)
                            },
                            expression: "podcast.title"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          attrs: {
                            type: "text",
                            label: "Enter Podcast description",
                            placeholder: "Enter Podcast description",
                            "data-vv-name": "description",
                            "cus-name": "description"
                          },
                          model: {
                            value: _vm.podcast.description,
                            callback: function($$v) {
                              _vm.$set(_vm.podcast, "description", $$v)
                            },
                            expression: "podcast.description"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Enter Podcast artist",
                            placeholder: "Enter Podcast artist",
                            "data-vv-name": "artist",
                            "cus-name": "artist"
                          },
                          model: {
                            value: _vm.podcast.artist,
                            callback: function($$v) {
                              _vm.$set(_vm.podcast, "artist", $$v)
                            },
                            expression: "podcast.artist"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.quote,
                              expression: "rules.quote"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Podcast URL",
                            placeholder: "Enter Podcast Url",
                            "data-vv-name": "podcastUrl",
                            "cus-name": "podcastUrl",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.podcast.podcastUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.podcast, "podcastUrl", $$v)
                            },
                            expression: "podcast.podcastUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Enter Read More Url",
                            placeholder: "Enter Read More Url",
                            "data-vv-name": "readMoreUrl",
                            "cus-name": "readMoreUrl"
                          },
                          model: {
                            value: _vm.podcast.readMoreUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.podcast, "readMoreUrl", $$v)
                            },
                            expression: "podcast.readMoreUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.status.length
                      ? _c(
                          "div",
                          { staticClass: "col-3" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.active,
                                  expression: "rules.active"
                                }
                              ],
                              attrs: {
                                label: "Status",
                                "data-vv-name": "active",
                                "cus-name": "active",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.status,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.podcast.active,
                                callback: function($$v) {
                                  _vm.$set(_vm.podcast, "active", $$v)
                                },
                                expression: "podcast.active"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Update Podcast\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Edit Podcast")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-032aab5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-032aab5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Podcast/EditPodcast.vue
// module id = quW0
// module chunks = 0